export default {
	de: {
		errorIcon: 'far fa-file-circle-xmark',
		error: '@:component.toast.error.fileNotFound',
		errorInfo:
			'Leider besteht daher keine Möglichkeit, das Dokument zu öffnen oder zu speichern. Bitte kontaktieren Sie hierzu Ihre Hausverwaltung.',
	},
	en: {
		errorIcon: 'far fa-file-circle-xmark',
		error: '@:component.toast.error.fileNotFound',
		errorInfo:
			'Unfortunately, it is not possible to open or save the document. Please contact your property management office.',
	},
}
